// eslint-disable-next-line
import axios from 'axios'
import { colorChange, productFormSubmit, variantChange } from '../../../scripts/helpers/product-form'
import Swiper from 'swiper'
import { debounce } from '~/helpers/general'
import { getLocalURL } from '../../../scripts/helpers/globale'

export default class ProductForm {
  constructor(component) {
    this.dom = {
      $component: component,
      $body: document.querySelector('body'),
      $singleOptionSelectors: component.querySelectorAll('.js-singleOptionSelector'),
      $options: component.querySelectorAll('.js-option'),
      $sizeGuideToggles: document.querySelectorAll('.js-sizeGuideToggle'),
      $sizeGuide: document.querySelector('.js-sizeGuide'),
      $sizeGuideUnderlay: document.querySelector('.js-sizeGuideUnderlay'),
      $reviewsBtn: component.querySelector('.js-scrollToReviews'),
      $variantIdInput: component.querySelector('.js-variantId'),
      $price: component.querySelector('.js-price .currency-formatting'),
      $compareAtPrice: component.querySelector('.js-compareAtPrice'),
      $submitBtn: component.querySelector('.js-productFormSubmit'),
      $wishListButton: component.querySelector('.js-iWishAdd'),
      $swatchSelector: component.querySelector('.js-colorOptionsSelector'),
      $swatchOptionsContainer: component.querySelector('.js-colorOptions'),
      $swatchPlaceholder: component.querySelector('.js-slide-placeholder'),
      $collectionBreadcrumb: component.querySelector('.js-breadcrumbItem'),
      $selectedOptionText: component.querySelectorAll('.js-selectedOption'),
      $singleOptionSelectorsContainer: component.querySelectorAll('.js-singleOptionsContainer'),
      $fixedOptionsContainer: component.querySelectorAll('.js-fixedOptionsContainer'),
      $appsContainer: component.querySelector('.js-product-apps'),
      $notEligible: component.querySelector('.js-not-eligible'),
      $crossSells: component.querySelector('.js-cross-sell-wrapper'),
      $promoTagContainer: component.querySelector('.js-product-tag-promo'),
    }
    this.state = {
      isFixedForm: false,
      selectedOptions: {},
      openOptionsClass: 'openOptions',
      selectedOptionClass: 'selectedOption',
      altSelectedOptionClass: 'activeOption',
      optionTextClass: '.js-selectedOption',
      openOptions: null,
      productInWishlist: false,
      inWishListButtonClass: '.js-iWishAdd',
      inWishlistClass: 'inWishlist',
      sizeGuideOpen: false,
      sizeGuideOpenClass: 'openSizeGuide',
      sizeGuideUnderlayActiveClass: 'isActive',
      bodyFixedClass: 'bodyFixed',
      variantUnavailableClass: 'variantUnavailable',
      swatches: [],
      activeSwatch: null,
      swatchesLoaded: false,
      viewLessSwatchInit: false,
      colorOptionsCarousel: {
        container: '.js-colorOptionsCarousel',
        prev: '.js-colorOptionsCarouselPrev',
        next: '.js-colorOptionsCarouselNext',
      },
      swiper: null,
      specialTagClass: 'js-product-tag',
      mainTagClass: 'js-main-slider-badge',
    }
    this.singleOptionSelectorClickHandler = this.singleOptionSelectorClick.bind(this)
    this.optionClickHandler = this.optionClick.bind(this)
    this.optionEnterHandler = this.optionEnter.bind(this)
    this.optionLeaveHandler = this.optionLeave.bind(this)
    this.optionClickOutHandler = this.optionClickOut.bind(this)
    this.wishListClickHandler = this.wishListClick.bind(this)
    this.sizeGuideToggleHandler = this.sizeGuideToggle.bind(this)
    this.viewReviewsHandler = this.viewReviews.bind(this)
    this.submitHandler = this.submit.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    this.setSelectedOptions()
    this.checkWishlist()
    dom.$singleOptionSelectors.forEach(($selector) => $selector.addEventListener('click', this.singleOptionSelectorClickHandler))
    dom.$options.forEach(($option) => $option.addEventListener('click', this.optionClickHandler))
    dom.$submitBtn.addEventListener('click', this.submitHandler)
    this.wishListHandler()
    dom.$sizeGuideToggles.forEach(($toggle) => $toggle.addEventListener('click', this.sizeGuideToggleHandler))
    this.loadSwatches()

    window.addEventListener('resize', debounce(this.refreshSwatchCarousel.bind(this), 300))
    if (dom.$reviewsBtn) {
      dom.$reviewsBtn.addEventListener('click', this.viewReviewsHandler)
    }

    window.basis.EventBus.listen('colorchange-variants', (productData) => {
      this.mountVariantSwatches(productData)
    })

    window.basis.EventBus.listen('fixed-form-colorchange', (data) => {
      const { relatedProductUrl, optionValue } = data
      this.handleColorClick(relatedProductUrl, optionValue)
    })

    window.basis.EventBus.listen('setSelectOptions', () => {
      this.setSelectedOptions()
    })

    window.basis.EventBus.listen('update-wishlist-state', () => {
      this.checkWishlist()
    })
  }

  wishListHandler() {
    const { dom } = this
    if (dom.$wishListButton) {
      dom.$wishListButton.addEventListener('click', this.wishListClickHandler)
    }
  }

  async loadSwatches() {
    const { dom, state } = this

    if (!dom.$swatchSelector) {
      state.swatchesLoaded = true
      return
    }

    try {
      const { group, color } = dom.$swatchSelector.dataset
      const url = `/collections/all/${group}?view=swatch-data`
      const { data: { products } } = await axios.get(url)
      state.swatches = products.sort((a, b) => {
        return a.colorHandle.localeCompare(b.colorHandle)
      })

      const event = new CustomEvent('swatchesloaded', { detail: { products, color } })
      document.dispatchEvent(event)

      state.activeSwatch = color
      this.mountSwatches()
      state.swatchesLoaded = true
      this.createColorOptionCarousel()
      this.setSelectedOptions()
    } catch (event) {
      // eslint-disable-next-line
      console.log('Product Form: Error loading swatches', event)
    }
  }

  mountSwatches() {
    const { dom, state } = this
    const currentHandle = window.location.pathname.split('/products')[1]
    const foundIdx = state.swatches.findIndex((swatch) => {
      return swatch.url.includes(currentHandle)
    })

    dom.$swatchPlaceholder?.remove()
    const currentSwatch = state.swatches[foundIdx]
    state.swatches.splice(foundIdx, 1)
    state.swatches.unshift(currentSwatch)

    state.swatches.forEach((swatch, index) => {
      if (!swatch.rendered) {
        this.createSwatch(swatch, index)
      }
    })

    if (state.viewLessSwatchInit === false &&
      window.innerWidth > 767 &&
      state.swatches.length > 6
    ) {
      this.createViewLessSwatchButton()
    }

    this.setOutofStockOptions()
  }

  mountVariantSwatches(productData) {
    const { dom } = this

    dom.$singleOptionSelectorsContainer.forEach((option) => {
      if (option.dataset.option !== 'color') {
        const buttons = this.createVariantSwatch(productData, option)
        const wrapper = document.createElement('div')
        wrapper.innerHTML = buttons.join('')
        option.querySelector('.js-optionContainer').innerHTML = buttons.join('')
        dom.$options = document.querySelectorAll('.js-option')
        dom.$options.forEach(($option) => $option.addEventListener('click', this.optionClickHandler))
      }
    })

    window.basis.EventBus.emit('refresh-fixed-variants', productData)
  }

  createVariantSwatch(productData, option) {
    const { state } = this
    const { options, variants } = productData
    const sanitizeOptions = options.map((optionItem) => {
      return optionItem.toLowerCase()
    })
    const index = sanitizeOptions.indexOf(option.dataset.option)
    const optionType = sanitizeOptions[index]
    const selected = state.selectedOptions[sanitizeOptions[index]]

    const buttons = variants.map((variant) => {
      const value = variant.options[index]
      const selectClass = variant.options[index] === selected ? 'selectedOption' : ''
      const soldOutClass = variant.available ? '' : 'sold-out'

      return `
        <button
        class="
          ProductForm__singleOptionSelector__option
          ProductForm__singleOptionSelector__option--${optionType}
          js-option
          ${selectClass}
          ${soldOutClass}
        "
        data-value="${value}"
        data-option-type="${optionType}"
        aria-label="Select ${value} option"
      >
        <span class="rmp">${value}</span>
      </button>
      `
    })

    return buttons
  }

  createSwatch(swatch, index) {
    const { dom } = this
    const button = document.createElement('button')
    const wrapper = document.createElement('div')
    const breadcrumbLink = dom.$collectionBreadcrumb
    const collectionUrl = breadcrumbLink ? breadcrumbLink.attributes.href.value : ''
    if (index > 6) {
      wrapper.classList.add(`ProductForm__swiper-slide--collapsible`)
      button.tabIndex = -1
    }

    if (!swatch.available) {
      wrapper.classList.add('sold-out')
    }

    wrapper.classList.add('swiper-slide')
    wrapper.classList.add(`ProductForm__swiper-slide--${index}`)
    wrapper.classList.add('ProductForm__singleOptionSelector__option')
    button.classList.add('js-option')
    button.classList.add('swatch-button')
    button.dataset.slideIndex = index
    button.dataset.optionType = 'color'
    button.dataset.value = swatch.colorHandle
    button.value = swatch.colorHandle
    button.ariaLabel = `Select ${swatch.colorFormatted} color option`

    this.setActiveSwatch(swatch.color, wrapper, button)
    // if (swatch.color === state.activeSwatch) {
    //   wrapper.classList.add('active-swatch')
    //   button.classList.add('selectedOption')
    // }

    if (collectionUrl) {
      button.dataset.relatedProductUrl = `${collectionUrl}${swatch.url}`
    } else {
      button.dataset.relatedProductUrl = getLocalURL(swatch.url)
    }

    button.innerHTML = `
      <span class="ProductForm__color-option--spacer"></span>
      <img class="ProductForm__color-option" src="${swatch.images[0].src} alt="${swatch.images[0].alt}"/>
    `

    button.addEventListener('click', this.optionClickHandler)
    button.addEventListener('mouseenter', this.optionEnterHandler)
    button.addEventListener('mouseleave', this.optionLeaveHandler)

    wrapper.append(button)
    dom.$swatchOptionsContainer.append(wrapper)
    swatch.rendered = true
  }

  setActiveSwatch(color, wrapper, button) {
    const { dom, state } = this
    if (!color) {
      const activeSwatchWrapper = dom.$swatchOptionsContainer.querySelector('.active-swatch')
      if (activeSwatchWrapper) {
        const activeSwatchButton = activeSwatchWrapper.querySelector('.js-option')
        activeSwatchWrapper.classList.remove('active-swatch')
        activeSwatchButton.classList.remove('selectedOption')
      }

      const newActive = Array.from(dom.$swatchOptionsContainer.querySelectorAll('.js-option')).find((option) => {
        return option.value === state.activeSwatch
      })

      newActive.closest('div').classList.add('active-swatch')
      newActive.classList.add('selectedOption')
    }

    if (color === state.activeSwatch) {
      wrapper.classList.add('active-swatch')
      button.classList.add('selectedOption')
    }
  }

  setSelectedOptions() {
    const { dom, state } = this

    dom.$component.querySelectorAll(`.${state.selectedOptionClass}`).forEach((btn) => {
      const { optionType, value } = btn.dataset
      state.selectedOptions[optionType] = value
    })
  }

  /**
   * Set out of stock options
   */
  setOutofStockOptions() {
    const { dom, state } = this
    if (state.swatches.length < 1) {
      return
    }

    const currentOutofStock = state.swatches[0].variants.filter((variant) => {
      return variant.variantAvailable === false
    })

    if (currentOutofStock.length < 1) {
      return
    }

    const selectContainers = Array.from(dom.$singleOptionSelectorsContainer)
    currentOutofStock.forEach((variant) => {
      for (const [key, value] of Object.entries(variant.variantOptions)) {
        const optionName = key.toLowerCase()

        if (optionName !== 'color') {
          const optionSelectors = selectContainers.find((selectorsGroup) => {
            return selectorsGroup.dataset.option === optionName
          })

          if (!optionSelectors) {
            return
          }

          const selectors = optionSelectors.querySelector('.js-optionContainer')
          const findOption = selectors.querySelector(`[data-value="${value}"]`)

          if (!findOption) {
            return
          }

          findOption.classList.add('sold-out')
        }
      }
    })
  }

  checkWishlist() {
    const { dom, state } = this
    if (!dom.$wishListButton) {
      return
    }

    const { productId, currentVariantId } = dom.$wishListButton.dataset

    if (window.isInWishlist(productId, currentVariantId)) {
      state.productInWishlist = true
      dom.$wishListButton.classList.add(state.inWishlistClass)
    } else {
      state.productInWishlist = false
      dom.$wishListButton.classList.remove(state.inWishlistClass)
    }
  }

  singleOptionSelectorClick(event) {
    const { state } = this
    const container = event.currentTarget.closest('.js-singleOptionsContainer')
    const optionType = container.dataset.option

    if (state.openOptions === optionType) {
      this.closeOpenOption()
      state.openOptions = null
      return
    }

    if (state.openOptions) {
      this.closeOpenOption()
    }

    this.openOption(optionType)
    state.openOptions = optionType
  }

  optionClickOut(event) {
    const { dom, state } = this
    const activeContainer = dom.$component.querySelector(`.js-singleOptionsContainer[data-option="${state.openOptions}"]`)
    if (!activeContainer.contains(event.target)) {
      this.closeOpenOption()
      state.openOptions = null
    }
  }

  closeOpenOption() {
    const { dom, state } = this
    const activeContainer = dom.$component.querySelector(`.js-singleOptionsContainer[data-option="${state.openOptions}"]`)
    if (!activeContainer) {
      return
    }
    const activeContainerOptions = activeContainer.querySelector('.js-optionContainer')
    activeContainerOptions.setAttribute('aria-hidden', 'true')
    activeContainerOptions.setAttribute('aria-expanded', 'false')
    activeContainer.classList.remove(state.openOptionsClass)
    document.removeEventListener('click', this.optionClickOutHandler)
  }

  openOption(optionType) {
    const { dom, state } = this
    const activeContainer = dom.$component.querySelector(`.js-singleOptionsContainer[data-option="${optionType}"]`)
    const activeContainerOptions = activeContainer.querySelector('.js-optionContainer')
    activeContainerOptions.setAttribute('aria-hidden', 'false')
    activeContainerOptions.setAttribute('aria-expanded', 'true')
    activeContainer.classList.add(state.openOptionsClass)
    document.addEventListener('click', this.optionClickOutHandler)
  }

  optionClick(event) {
    const { dom, state } = this
    const optionValue = event.currentTarget.dataset.value
    const { optionType } = event.currentTarget.dataset
    const currentSelection = dom.$component.querySelector(`.js-option[data-value="${state.selectedOptions[optionType]}"]`)

    if (currentSelection) {
      currentSelection.classList.remove(state.selectedOptionClass)
    }

    const formattedStateValue = state.activeSwatch?.replace('/', '-').toLowerCase()

    if (optionValue !== formattedStateValue) {
      event.currentTarget.classList.add(state.selectedOptionClass)
      this.closeOpenOption()
      state.selectedOptions[optionType] = optionValue
      state.openOptions = null

      if (optionType === 'color') {
        state.activeSwatch = optionValue
        this.setActiveSwatch()
        this.setSelectedOptions()
        const { relatedProductUrl } = event.currentTarget.dataset
        colorChange(relatedProductUrl, this)
        window.basis.EventBus.emit('set-active-fixed-swatch', optionValue)
        return
      }

      variantChange(this)
    }
  }

  handleColorClick(relatedProductUrl, optionValue) {
    const { state } = this
    state.activeSwatch = optionValue
    this.setActiveSwatch()
    this.setSelectedOptions()
    colorChange(relatedProductUrl, this)
  }

  optionEnter(event) {
    const optionValue = event.currentTarget.value
    this.dom.$swatchSelector.querySelector('.ProductForm__singleOptionSelector__selectedWrap').innerHTML = `Color: ${optionValue.replace('-', '/')}`
  }

  optionLeave() {
    const { state } = this
    this.dom.$swatchSelector.querySelector('.ProductForm__singleOptionSelector__selectedWrap').innerHTML = `Color: ${state.activeSwatch.replace('-', '/').toLowerCase()}`
  }

  wishListClick(event) {
    const { dom, state } = this
    if (state.productInWishlist) {
      return
    }
    const {
      productId,
      productTitle,
      currentVariantId,
      customer,
    } = event.currentTarget.dataset

    if (customer) {
      window.iwish_addOnly(productId, currentVariantId, productTitle)
      dom.$wishListButton.classList.add(state.inWishlistClass)
      state.productInWishlist = true
    } else {
      const customEvent = new Event('loginModalToggle')
      document.dispatchEvent(customEvent)
    }
  }

  submit(event) {
    event.preventDefault()
    productFormSubmit(this)
  }

  sizeGuideToggle() {
    const { dom, state } = this

    if (state.sizeGuideOpen) {
      dom.$sizeGuide.setAttribute('aria-hidden', 'true')
      dom.$sizeGuide.setAttribute('aria-expanded', 'false')
      dom.$sizeGuide.classList.remove(state.sizeGuideOpenClass)
      dom.$sizeGuideUnderlay.classList.remove(state.sizeGuideUnderlayActiveClass)
      dom.$body.classList.remove(state.bodyFixedClass)
      state.sizeGuideOpen = false
    } else {
      dom.$sizeGuide.setAttribute('aria-hidden', 'false')
      dom.$sizeGuide.setAttribute('aria-expanded', 'true')
      dom.$sizeGuide.classList.add(state.sizeGuideOpenClass)
      dom.$sizeGuideUnderlay.classList.add(state.sizeGuideUnderlayActiveClass)
      if (window.innerWidth <= 1024) {
        dom.$body.classList.add(state.bodyFixedClass)
      }
      state.sizeGuideOpen = true
    }
  }

  viewReviews() {
    const reviewsSection = document.querySelector('.js-productReviews')
    reviewsSection.scrollIntoView()
  }

  /**
   * Destroy and then rebuilt swatch carousel
   */
  refreshSwatchCarousel() {
    const { state } = this
    state.swiper.destroy()
    this.createColorOptionCarousel()
  }

  /**
   * Create swatch carousel view less button
   */
  createViewLessSwatchButton() {
    const { dom, state } = this
    const { lessSwatches } = window.theme.strings.productPage.productForm
    const button = document.createElement('button')
    const slide = document.createElement('div')
    const wrapper = document.createElement('div')
    const textWrap = document.createElement('span')

    textWrap.classList.add('swatch-hide__text')
    textWrap.innerText = lessSwatches

    slide.classList.add('swiper-slide')
    wrapper.classList.add('swatch-hide')
    button.append(textWrap)
    button.tabIndex = -1
    button.dataset.slideIndex = state.swatches.length
    wrapper.append(button)
    slide.append(wrapper)
    dom.$swatchOptionsContainer.append(slide)
    state.viewLessSwatchInit = true
  }

  /**
   * Create swatch carousel view more button
   */
  createViewMoreSwatchButton() {
    const { state } = this
    let moreSwatchButton = null
    let wrapper = null

    if ((window.innerWidth >= 768 && state.swatches.length <= 7) ||
      (window.innerWidth < 768 && state.swatches.length < 6)
    ) {
      state.swiper.disable()
      return
    }

    if (window.innerWidth >= 768 && state.swiper.slides.length > 7) {
      const lastSlide = state.swiper.slides[state.swiper.slides.length - 1]
      const viewLessButton = lastSlide.querySelector('button')
      state.swiper.$el[0].classList.add('is-disabled')
      state.swiper.disable()

      const hasMoreSwatchButton = Array.from(state.swiper.slides).find((slide) => {
        return slide.querySelector('.js-more-swatches')
      })

      if (hasMoreSwatchButton) {
        moreSwatchButton = hasMoreSwatchButton.querySelector('.js-more-swatches')
        moreSwatchButton.closest('.swatch-reveal').classList.remove('is-hidden')
      } else {
        const viewMoreCount = state.swiper.slides.length - 7
        const slideMoreCover = state.swiper.slides[6]
        const { moreSwatches } = window.theme.strings.productPage.productForm
        const moreText = `${moreSwatches}`.replace('{{ count }}', viewMoreCount)
        const textWrap = document.createElement('span')

        wrapper = document.createElement('div')
        moreSwatchButton = document.createElement('button')
        textWrap.classList.add('swatch-reveal__text')
        textWrap.innerText = moreText

        wrapper.classList.add('swatch-reveal')
        moreSwatchButton.prepend(textWrap)
        moreSwatchButton.classList.add('js-more-swatches')
        moreSwatchButton.tabIndex = 0
        wrapper.prepend(moreSwatchButton)
        slideMoreCover.prepend(wrapper)
      }

      this.updateSwiperEventListeners(moreSwatchButton, viewLessButton, lastSlide, wrapper)
    }
  }

  /**
   * Update swiper event listeners
   * @param {HTMLElement} moreSwatchButton - view more slide button
   * @param {HTMLElement} viewLessButton - view less slide button
   * @param {HTMLElement} lastSlide - last slide containing
   * @param {HTMLElement} veiwMoreWrapper - view more slide wrapper
   *
   */
  updateSwiperEventListeners(moreSwatchButton, viewLessButton, lastSlide, veiwMoreWrapper) {
    moreSwatchButton.addEventListener('click', () => {
      this.handleExpandSwatchSlides(viewLessButton, veiwMoreWrapper)
    })

    lastSlide.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        this.handleCollapseSwatchSlides(viewLessButton, veiwMoreWrapper)
      }
    })

    lastSlide.addEventListener('click', () => {
      this.handleCollapseSwatchSlides(viewLessButton, moreSwatchButton, veiwMoreWrapper)
    })
  }

  /**
   * Update swiper event listeners
   * @param {HTMLElement} viewLessButton - view less slide button
   * @param {HTMLElement} veiwMoreWrapper - view more slide wrapper
   *
   */
  handleExpandSwatchSlides(viewLessButton, veiwMoreWrapper) {
    const { state } = this
    Array.from(state.swiper.slides).forEach((slide) => {
      const classList = Array.from(slide.classList)

      if (classList.includes('ProductForm__swiper-slide--collapsible')) {
        slide.querySelector('button').tabIndex = 0
      }
    })

    veiwMoreWrapper.classList.add('is-hidden')
    viewLessButton.tabIndex = 0
    this.swiperEnable()
  }

  /**
   * Update swiper event listeners
   * @param {HTMLElement} moreSwatchButton - view more slide button
   * @param {HTMLElement} viewLessButton - view less slide button
   * @param {HTMLElement} veiwMoreWrapper - view more slide wrapper
   *
   */
  handleCollapseSwatchSlides(viewLessButton, moreSwatchButton, veiwMoreWrapper) {
    const { state } = this
    viewLessButton.blur()
    moreSwatchButton.focus()

    Array.from(state.swiper.slides).forEach((slide) => {
      const classList = Array.from(slide.classList)
      if (classList.includes('ProductForm__swiper-slide--collapsible')) {
        slide.querySelector('button').tabIndex = -1
      }
    })

    veiwMoreWrapper.classList.remove('is-hidden')
    viewLessButton.tabIndex = -1
    this.swiperDisable()
  }

  /**
   * Enable swiper
   */
  swiperEnable() {
    const { state } = this
    state.swiper.updateSlides()
    state.swiper.$el[0].classList.remove('is-disabled')
    state.swiper.$el[0].classList.add('is-enabled')
    state.swiper.enable()
  }

  /**
   * Disable swiper
   */
  swiperDisable() {
    const { state } = this
    state.swiper.slideTo(0, 400, true)
    state.swiper.$el[0].classList.add('is-disabled')
    state.swiper.$el[0].classList.remove('is-enabled')
    state.swiper.disable()
  }

  /**
   * Create carousel for color options
   */
  createColorOptionCarousel() {
    const { state } = this

    state.swiper = new Swiper(state.colorOptionsCarousel.container, {
      slidesPerView: 5.5,
      spaceBetween: 6,
      loop: false,
      a11y: true,
      lazy: true,
      centeredSlides: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
      navigation: {
        prevEl: state.colorOptionsCarousel.prev,
        nextEl: state.colorOptionsCarousel.next,
      },
      breakpoints: {
        768: {
          slidesPerView: 7.2,
        },
      },
    })

    // custom keyboard tab slide change
    state.swiper.$el[0].addEventListener('keyup', (event) => {
      event.preventDefault()

      if (event.keyCode === 9) {
        const activeIndex = document.activeElement.dataset.slideIndex
        state.swiper.slideTo(activeIndex, 400, true)
      }
    })

    this.createViewMoreSwatchButton()
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductForm = this

    if (typeof window.Klarna !== 'undefined' && window.Klarna.OnsiteMessaging) {
      window.Klarna.OnsiteMessaging.refresh()
    }
  }
}
